<template>
  <div>
    <van-popup
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
      :style="{ height: '40%' }"
    >
      <van-picker
        show-toolbar
        value-key="cityName"
        :columns="cityColumns"
        @change="onChange"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { Picker, Popup } from 'vant'
import { getProvince } from 'Utils/publicApi'

export default {
  components: {
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },
  props: {
    visibility: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isShow: false,
      citys: {},
      cityColumns: []
    }
  },
  async created() {
    let data = await getProvince()

    const PROVINCE = data.province['00002'] // 省份
    const CITY = data.city // 城市
    
    PROVINCE.forEach(province => {
      this.citys[province.cName] = []

      if (CITY[province.id]) {
        CITY[province.id].forEach(city => {
          this.citys[province.cName].push({
            provinceId: province.id,
            cityId: city.id,
            cityName: city.cityName
          })
        })
      }
    })
    
    this.cityColumns = [
      {	values: Object.keys(this.citys) },
      {	values: this.citys[PROVINCE[0].cName] }
    ]
  },
  methods: {
    onChange (picker, values) {
      picker.setColumnValues(1, this.citys[values[0]])
    },
    onConfirm (picker, values) {
      this.isShow = false
      this.$emit('confirm', picker, values)
    },
    onCancel () {
      this.isShow = false
    }
  },
  watch: {
    visibility (val) {
      this.isShow = val
    },
    isShow (val) {
      this.$emit('update:visibility', val)
    }
  }
}
</script>